<template>
  <div class="grid-container sm:justify-center py-14">
    <div class="flex justify-center w-full">
      <div class="bdt-prose max-w-full sm:max-w-[65ch]">
        <h1>Términos y condiciones</h1>
        <em>
          &Uacute;ltima actualizaci&oacute;n:&nbsp; 16 Mayo de 2022
        </em>
        <p>
          El presente documento contiene los t&eacute;rminos y condiciones entre el Suscriptor y
          BOLSA DE TRABAJO para la plataforma de Bolsa de trabajo en el siguiente detalle:
        </p>
        <h2>1. Definiciones</h2>
        <p>
          SUSCRIPTOR: El Usuario -persona f&iacute;sica o jur&iacute;dica- que se registra y
          suscribe al servicio digital para adquirir el producto para el uso.
        </p>
        <p>
          PRODUCTOS: Sitios web donde las empresas pueden cargar sus ofertas de empleo disponibles y
          el p&uacute;blico en general puede aplicar en ellas.
        </p>
        <p>CONDICIONES: El clausulado del presente contrato.</p>
        <p>
          SITIO WEB: El presente contrato y sus CONDICIONES podr&aacute;n sufrir, en cualquier
          momento, modificaciones, las cuales ser&aacute;n informadas en su caso al SUSCRIPTOR al
          correo electr&oacute;nico con el cual ha creado su perfil.
        </p>
        <h2>2. Partes Contratantes</h2>
        <p>
          De una parte, BOLSA DE TRABAJO con domicilio Boulevard Santa Elena, La Libertad, El Salvador,
          cuya actividad principal consiste en la publicaci&oacute;n de los PERI&Oacute;DICOS y/o
          REVISTAS y sus suplementos; y, de otra parte, el SUSCRIPTOR, cuyas cualidades ser&aacute;n
          visibles en el Formulario de Suscripci&oacute;n. El SUSCRIPTOR no podr&aacute; ceder a
          terceros (Que no sean de la misma raz&oacute;n social) los derechos de este contrato,
          cualquier cambio en los datos del SUSCRIPTOR deber&aacute; ser adicionado por las
          v&iacute;as establecidas.
        </p>
        <h2>
          3. Objeto de t&eacute;rminos y condiciones
        </h2>
        <p>
          El objeto es delimitar las condiciones de SUSCRIPCI&Oacute;N a los PRODUCTOS de BOLSA DE TRABAJO,
          los cuales recibir&aacute; el SUSCRIPTOR a cambio de la contraprestaci&oacute;n
          econ&oacute;mica seg&uacute;n la modalidad y productos contratados. EL SUSCRIPTOR
          recibir&aacute; el acceso a los PRODUCTOS &nbsp;que formen parte de la oferta contratada.
          No formar&aacute;n parte de la suscripci&oacute;n las ofertas de productos que se
          promocionen previo el pago de un precio adicional. Cumpliendo con las condiciones de
          registro y pago, cada suscriptor podr&aacute; acceder de forma ilimitada a su perfil de
          empresa para consultar su informaci&oacute;n, aplicantes a oportunidades laborales y para
          actualizar su informaci&oacute;n personal.
        </p>
        <h2>
          4. Procedimiento de suscripci&oacute;n
        </h2>
        <p>
          Para afiliarse a la Bolsa de trabajo debe realizarlo v&iacute;a internet, ingresando al
          sitio web: bolsadetrabajo.laprensagrafica.com o a trav&eacute;s de un ejecutivo de venta
        </p>
        <p>
          Afiliaci&oacute;n: Para la suscripci&oacute;n a Bolsa de trabajo, primeramente el usuario
          deber&aacute; completar el Formulario de Registro, y posteriormente efectuar la compra de
          la suscripci&oacute;n anual (un solo pago) o en cuotas mensuales (que se renuevan
          anualmente de manera autom&aacute;tica) a trav&eacute;s del m&eacute;todo de pago
          disponible&nbsp;(Tarjeta de cr&eacute;dito/d&eacute;bito Visa/Mastercard o en
          efectivo/cheque a trav&eacute;s de un asesor de venta). BOLSA DE TRABAJO, notificar&aacute; al
          suscriptor al momento en que se encuentra habilitado para hacer uso de los productos y
          servicios por medio de correo electr&oacute;nico o a trav&eacute;s de una llamada
          telef&oacute;nica.
        </p>
        <h2>5. Tarifas y Pagos</h2>
        <p>
          Los precios de cada producto o servicio son en d&oacute;lares estadounidenses, por lo que
          el SUSCRIPTOR podr&aacute; conocer el detalle de su compra en forma clara y exacta, sin
          limitaci&oacute;n o restricci&oacute;n, esta informaci&oacute;n ser&aacute; visible en el
          sitio bolsadetrabajo.sv, El SUSCRIPTOR deber&aacute; pagar v&iacute;a tarjeta de
          cr&eacute;dito o d&eacute;bito, local o internacional, Visa o Mastercard en el
          m&eacute;todo de pago disponible o en efectivo/cheque a trav&eacute;s de un asesor de
          venta, seleccionando un plan de suscripci&oacute;n y la fecha que se realiza el pago,
          inicia el periodo de la suscripci&oacute;n. El SUSCRIPTOR se compromete al pago
          correspondiente a la suscripci&oacute;n del uso de los PRODUCTOS, por ende reconoce el
          periodo de pagos seleccionados. Los cobros por productos no son reembolsables, salvo que
          por excepci&oacute;n BOLSA DE TRABAJO, acuerde lo contrario, en cuyo caso ser&aacute; considerado
          como un acto de mera liberalidad que no lo obliga a futuro para resolver situaciones con
          caracter&iacute;sticas semejantes.
        </p>
        <p>
          BOLSA DE TRABAJO, podr&aacute; ofrecer a sus suscriptores, en cualquier momento, promociones en
          sus productos o servicios. El suscriptor que adquiera un producto o servicio en
          promoci&oacute;n deber&aacute; consignar la informaci&oacute;n de pago como requisito
          indispensable. Cada promoci&oacute;n tendr&aacute; un reglamento que regula las
          condiciones generales y los t&eacute;rminos espec&iacute;ficos. Por principio general, no
          se podr&aacute; aplicar m&aacute;s de dos promociones al mismo tiempo o bajo un mismo
          producto o servicio. En el sitio web se despliega la informaci&oacute;n del descuento que
          aplica y en los casos en que procede, los cuales son generados en forma inmediata, no
          pudiendo ser destinados en forma retroactiva bajo ning&uacute;n supuesto.
        </p>
        <p>
          Podemos cambiar nuestros planes de suscripci&oacute;n y el precio de nuestro servicio de
          vez en cuando. Sin embargo, cualquier cambio en los precios o en los planes de
          suscripci&oacute;n se aplicar&aacute; no antes de los 30 d&iacute;as siguientes a la
          notificaci&oacute;n.
        </p>
        <h2>6. Propiedad Intelectual</h2>
        <p>
          Todos los contenidos de los PRODUCTOS son de titularidad exclusiva de BOLSA DE TRABAJO Los
          PRODUCTOS constituyen una obra protegida por la legislaci&oacute;n en materia de Propiedad
          Intelectual por lo que no podr&aacute; ser reproducido, distribuido, transformado o
          comunicado p&uacute;blicamente en cualquier forma, salvo para uso personal por el
          SUSCRIPTOR. Asimismo, el SUSCRIPTOR no podr&aacute; duplicar, vender, revender o explotar
          de ninguna forma los PRODUCTOS ofrecidos por BOLSA DE TRABAJO. El SUSCRIPTOR acepta conocer y
          respetar la reserva de estos derechos que hace BOLSA DE TRABAJO. As&iacute; mismo BOLSA DE TRABAJO se
          reserva el derecho de tomar las medidas legales oportunas para ir contra aqu&eacute;llos
          que contravengan la presente cl&aacute;usula.
        </p>
        <h2>7. Resoluci&oacute;n</h2>
        <p>
          BOLSA DE TRABAJO, se reserva el derecho a resolver el presente contrato con aquellos SUSCRIPTORES
          que contravengan lo dispuesto en las presentes CONDICIONES, sin posibilidad de reembolso
          en caso de haberse efectuado el pago.
        </p>
        <h2>8. Consentimiento Informado</h2>
        <p>
          En la recopilaci&oacute;n de datos, el formulario identificar&aacute; la
          informaci&oacute;n que es de car&aacute;cter obligatorio; la cual es imprescindible para
          cumplir con la suscripci&oacute;n del servicio. Los datos suministrados por el suscriptor,
          deber&aacute;n ser reales, veraces, completos y actualizados. Esta informaci&oacute;n
          ser&aacute; almacenada por el tiempo necesario para cumplir sus fines, y en total apego a
          la ley. El fin primordial es brindarle el correcto servicio de entrega del producto al
          cual se suscribi&oacute;, y como fines secundarios la base de datos estar&aacute; dirigida
          a utilizar los medios de contacto para remitir, boletines informativos, felicitaciones en
          fechas especiales, informaci&oacute;n sobre alianzas o convenios con terceros, eventos
          especiales, y din&aacute;micas promocionales, estados de cuenta, avisos de cobro, sorteos
          o promociones, encuestas de opini&oacute;n y todos aquellos que tengan un fin
          &uacute;ltimo de prospecci&oacute;n comercial en beneficio de BOLSA DE TRABAJO.
        </p>
        <p>
          Se le garantiza el derecho a todo suscriptor a su Autodeterminaci&oacute;n Informativa,
          consecuentemente a ejercer los derechos de acceso, rectificaci&oacute;n,
          cancelaci&oacute;n o eliminaci&oacute;n y oposici&oacute;n de la informaci&oacute;n que
          haya suministrado, por medio de su perfil en la Bolsa de trabajo.
        </p>
        <p>
          Hacemos de su conocimiento que el tratamiento de la informaci&oacute;n ser&aacute;
          ejecutada por BOLSA DE TRABAJO, mediante Protocolos de Actuaci&oacute;n y de Seguridad, lo que
          garantiza el correcto, confidencial, y eficiente servicio. Hemos implementado
          pol&iacute;ticas de seguridad y confidencialidad, y se han aplicado todas las medidas de
          seguridad f&iacute;sicas y l&oacute;gicas, razonables para la protecci&oacute;n de la
          informaci&oacute;n de los suscriptores con el fin de evitar un uso no autorizado o fuera
          de los fines antes indicados.
        </p>
        <h2>
          9. Facturaci&oacute;n y cancelaci&oacute;n
        </h2>
        <h3>9.1. Ciclo de facturaci&oacute;n.</h3>
        <p>
          Los cargos por el servicio de suscripciones se cobrar&aacute;n a su Forma de pago en la
          fecha de pago espec&iacute;fica indicada en la p&aacute;gina &ldquo;Cuenta&rdquo;. La
          duraci&oacute;n de su ciclo de facturaci&oacute;n depender&aacute; del tipo de
          suscripci&oacute;n que haya seleccionado al suscribirse al servicio. En ciertos
          casos,&nbsp;su fecha de pago podr&iacute;a cambiar de acuerdo a los pagos o
          actualizaciones de suscripciones realizadas&nbsp;(En el caso que la suscripci&oacute;n se
          venza o se cancele, al volverla a activar su per&iacute;odo de facturaci&oacute;n
          cambiar&aacute; a la nueva fecha de activaci&oacute;n).
        </p>
        <h3>9.2. Formas de pago.</h3>
        <p>
          Para usar el servicio de suscripciones debe proveer una forma de pago o m&aacute;s. Nos
          autoriza a hacer cargos a la forma de pago asociada con su cuenta en caso de rechazo o
          indisponibilidad de su forma de pago principal el servicio se suspende. Cualquier cargo
          pendiente le corresponder&aacute; a usted ejecutar la aprobaci&oacute;n en la plataforma.
          Si el pago no se pudiera hacer satisfactoriamente, debido a la fecha de vencimiento, la
          falta de fondos o si usted no actualiza la informaci&oacute;n de su forma de pago o
          cancela su cuenta, podemos suspender su acceso al servicio hasta que obtengamos una forma
          de pago v&aacute;lida. Los impuestos locales ya est&aacute;n asociados en el precio final.
        </p>
        <h3>9.3. Cancelaci&oacute;n.</h3>
        <p>
          Puede cancelar la suscripci&oacute;n de suscripciones en cualquier momento, y
          continuar&aacute; teniendo acceso al servicio hasta el final de su per&iacute;odo de
          facturaci&oacute;n. En la medida permitida por la ley aplicable, los pagos no son
          reembolsables y no se otorgar&aacute;n reembolsos ni cr&eacute;ditos por los periodos de
          suscripci&oacute;n utilizados parcialmente o por el contenido no visto. Para cancelar,
          visite la p&aacute;gina &ldquo;Mi suscripci&oacute;n&rdquo;&nbsp;y siga las instrucciones.
          Si cancela su suscripci&oacute;n, su acceso se cerrar&aacute; autom&aacute;ticamente al
          final de su per&iacute;odo de facturaci&oacute;n actual. Para ver cu&aacute;ndo se
          vencer&aacute; su acceso, haga clic en &quot;Mi suscripci&oacute;n&quot;.
        </p>
        <h3>9.4 Cr&eacute;dito fiscal y detalle de compra.</h3>
        <p>
          Al momento de realizar una compra de una suscripci&oacute;n el detalle de compra
          estar&aacute; llegando al correo electr&oacute;nico asociado a la cuenta a la cual
          tendr&aacute; el servicio activado. En el caso que se requiera comprobante cr&eacute;dito
          fiscal para la compra, este debe ser solicitado al correo electr&oacute;nico&nbsp;<a
            href="mailto:hola@laprensagrafica.com"
            >hola@bolsadetrabajo.sv</a
          >&nbsp;adjuntando en formato pdf su tarjeta de IVA y correo asociado con el servicio.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Layouts/Layout'

export default {
  name: 'TermsAndConditions',
  layout: Layout,
}
</script>
